import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { OccupancySelection } from '../search-occupancy/search-occupancy.model';
import { createDateFromString } from '@app/controls/calendar/calendar.utils';
import { Params } from '@angular/router';

export const extractDatesAndOccupancyIdFromQueryParams = (
    queryParams: Params
): {
    fromDate: NgbDate;
    toDate: NgbDate;
    occupancy: OccupancySelection;
} => {
    const fromDateString = queryParams['fromDate'];
    const toDateString = queryParams['toDate'];
    const occupancyString = queryParams['occupancy'];

    if (
        areParamsInvalid({
            fromDate: fromDateString,
            toDate: toDateString,
            occupancy: occupancyString,
        })
    ) {
        return;
    }

    const fromDate = createDateFromString(fromDateString);
    const toDate = createDateFromString(toDateString);
    const occupancy = JSON.parse(occupancyString);

    return { fromDate, toDate, occupancy };
};

const areParamsInvalid = (params: {
    fromDate: unknown;
    toDate: unknown;
    occupancy: unknown;
}): boolean => {
    return (
        !params.fromDate ||
        params?.fromDate === 'undefined' ||
        !params.toDate ||
        params.toDate === 'undefined' ||
        !params.occupancy ||
        params.occupancy === 'undefined'
    );
};
